import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-unnecessary-type-parameters */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { type MessageKeys, type Messages, type NamespaceKeys, type NestedKeyOf, type NestedValueOf, type createTranslator,
// eslint-disable-next-line no-restricted-syntax
useTranslations } from "next-intl";
type IntlMessages = Record<string, any>;
// taken from next-intl
type NamespacedMessageKeys<TranslatorMessages extends IntlMessages, Namespace extends NamespaceKeys<TranslatorMessages, NestedKeyOf<TranslatorMessages>> = never> = MessageKeys<NestedValueOf<{
  "!": TranslatorMessages;
}, [Namespace] extends [never] ? "!" : `!.${Namespace}`>, NestedKeyOf<NestedValueOf<{
  "!": TranslatorMessages;
}, [Namespace] extends [never] ? "!" : `!.${Namespace}`>>>;
export function MissingMessageFallback(t0) {
  const $ = _c(3);
  const {
    result,
    k,
    namespace
  } = t0;
  const t1 = `Missing message: ${namespace ? `${namespace}.` : ""}${k}`;
  let t2;
  if ($[0] !== result || $[1] !== t1) {
    t2 = <span className="underline decoration-dashed" title={t1}>{result}</span>;
    $[0] = result;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function useTranslation(namespace) {
  const $ = _c(8);
  const t = useTranslations(namespace);
  let t0;
  if ($[0] !== namespace || $[1] !== t) {
    t0 = (...t1) => {
      const args = t1;
      const result = (t as any).rich(...args, {
        em: _temp
      });
      if (typeof result === "string" && result.includes("__fallback__")) {
        const [, ...rest] = result.split("__fallback__");
        const k = args[0] as string;
        return <MissingMessageFallback namespace={namespace} k={k} result={rest.join("__fallback__")} />;
      }
      return result;
    };
    $[0] = namespace;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const fn = t0 as unknown as T;
  let t1;
  if ($[3] !== fn || $[4] !== t) {
    let t2;
    if ($[6] !== t) {
      t2 = (key, values) => (t as any)(key, values);
      $[6] = t;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = Object.assign(fn, {
      rich: t.rich.bind(fn),
      markup: t.markup.bind(fn),
      raw: t.raw.bind(fn),
      has: t.has.bind(fn),
      plain: t2
    });
    $[3] = fn;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function _temp(text) {
  return <em>{text}</em>;
}
export function useCommon() {
  return useTranslation("Common");
}